module.exports = __webpack_public_path__ + "static/merchant-3e24bb89c2bf7ac5760e5ba59b96b83a.svg";